import $ from 'jquery'
export default {
    name: "autre-prestation",
    components: {},
    // props: [
    //   "slug",
    //   "user_id",
    //   "facture_id",
    //   "patient_id",
    //   "est_assure",
    //   "taux_prestation",
    // ],
    props: {
        user_id: Number,
        info_patient: Object,
        info_prestation: Object,
        info_patient_assure: Object
    },
    data() {
        return {
            save_loading: false,
            prestation: {
                libelle: "",
                prix: "",
                base_assurance: "",
            },
        };
    },

    computed: {},

    mounted() { },

    methods: {
        async submit() {
            const isValid = await this.$refs.other_form.validate();

            if (!isValid) {
                return;
            }
            this.save_loading = true

            let prestation_data = [
                {
                    id: 0,
                    nom: this.prestation.libelle,
                    prix_clinique: this.prestation.prix,
                    qte: 1,
                    prix_base_calcul: this.prestation.base_assurance,
                    data_type: this.info_prestation.slug
                }
            ]

            prestation_data = this.setPrestationUID(prestation_data)

            let data = {
                user_id: this.user_id,
                patient_id: this.info_patient.id,
                prestations: prestation_data,
                type_prestation: this.info_prestation.libelle,
                data_type: this.info_prestation.slug
            }

            // let data = {
            //     prestation: this.prestation.libelle,
            //     prix: parseInt(this.prestation.prix),
            //     base_assurance: this.prestation.base_assurance,
            //     user_id: this.user_id,
            //     patient_id: this.patient_id,
            //     est_assure: this.est_assure,
            //     type_prestation: this.slug,
            //     taux_prestation: this.taux_prestation,
            // };
            console.log(data);

            // this.$store
            //     .dispatch("saveAutrePrestationProforma", data)
            //     .then((response) => {
            //         if (response > 0) {
            //             this.facture_id = response;
            //             this.successToast("Ajout effectué avec succès");

            //             if (this.slug == "analyse") {
            //                 this.$emit("emitAnalyseFproforma", response);
            //             } else if (this.slug == "examen") {
            //                 this.$emit("emitExamenFproforma", response);
            //             } else if (this.slug == "medicament") {
            //                 this.$emit("emitPharmacieFproforma", response);
            //             } else if (this.slug == "soins") {
            //                 this.$emit("emitSoinsFproforma", response);
            //             } else if (this.slug == "chirurgie") {
            //                 this.$emit("emitChirurgieFproforma", response);
            //             } else if (this.slug == "autre") {
            //                 this.$emit("emitAutreFproforma", response);
            //             }

            //             this.prestation = {
            //                 libelle: "",
            //                 prix: "",
            //             };

            //             this.$refs.other_form.reset();
            //             this.$refs.fpro_other.click();

            //             this.one_is_checked = [];

            //             if (this.$route.params.proforma_id == 0) {
            //                 this.$router.push({
            //                     path: "/factures/ajout-facture-proforma/" + response,
            //                 });
            //             }
            //         }
            //         this.save_loading = false;
            //     });
        },

        async onlyDigit(selector) {
            console.log(selector);
            $("#" + selector).val(
                $("#" + selector)
                    .val()
                    .replace(/[^0-9]+/g, "")
            );
        },
    },
};


